import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import '../map/cairn-map.js'

@customElement('plan-map')
export class PlanMap extends LitElement {
  static override styles = css`
    :host {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
    }

    .header {
      display: flex;
      align-items: center;
      padding: var(--cairn-spacing-md, 16px);
      background: var(--cairn-surface-color, #ffffff);
      border-bottom: 1px solid var(--cairn-border-color, #e2e8f0);
      flex-shrink: 0;
    }

    .back-button {
      display: flex;
      align-items: center;
      justify-content: center;
      background: none;
      border: none;
      cursor: pointer;
      padding: 4px;
      border-radius: 50%;
      margin-right: var(--cairn-spacing-sm, 8px);
      color: var(--cairn-text-color, #1e293b);
    }

    .back-button:hover {
      background: var(--cairn-surface-hover-color, #f1f5f9);
    }

    .header-title {
      font-size: var(--cairn-text-size-xl, 24px);
      font-weight: var(--cairn-font-weight-bold, 600);
      color: var(--cairn-text-color, #1e293b);
      margin: 0;
    }

    cairn-map {
      flex: 1;
      min-height: 0;
    }

    .material-icons {
      font-family: 'Material Symbols Outlined';
      font-weight: normal;
      font-style: normal;
      font-size: 24px;
      line-height: 1;
      display: inline-block;
    }

    @media (min-width: 769px) {
      .header {
        display: none;
      }
    }
  `

  @property({ type: String }) planId?: string

  override render(): unknown {
    return html`
      <div class="header">
        <button class="back-button" @click=${() => window.history.back()}>
          <span class="material-icons">arrow_back</span>
        </button>
        <h1 class="header-title">Plan Route</h1>
      </div>
      <cairn-map .planId=${this.planId} ?disableLocation=${true}></cairn-map>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'plan-map': PlanMap
  }
}
